// extracted by mini-css-extract-plugin
export default {"ant-table-thead":"TableProduction_ant-table-thead__3NaEi","ant-table-cell":"TableProduction_ant-table-cell__VUdMg","hoverRow":"TableProduction_hoverRow__Djzak"};